import idx from 'idx'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import withMixpanel, { SCREEN_VIEW_GROUP_VIEWERS } from 'utils/mixpanel'
import { compose, lifecycle, withHandlers, withStateHandlers } from 'recompose'

import { isEqual, getPaginationObject } from 'utils/misc'

import * as toastModule from 'modules/toast'
import * as peopleModule from 'modules/people'
import * as userActions from 'actions/userActions'
import * as routeActions from 'actions/routeActions'

export default compose(
  withMixpanel,
  connect(
  // mapStateToProps
    (state) => {
      return {
        user: idx(state, _ => _.user) || null,
        group: idx(state, _ => _.groups.selected),
        viewers: idx(state, _ => _.people.approved),
        tableLoading: idx(state, _ => _.people.loading),
        organisation: idx(state, _ => _.organisation.selected)
      }
    },
    // mapDispatchToProps
    (dispatch) => {
      const actions = {
        ...userActions,
        ...toastModule,
        ...routeActions,
        ...peopleModule,
      }

      return {
        actions: bindActionCreators(actions, dispatch),
      }
    },
  ),
  withStateHandlers(
    () => ({
      filters: {
        search: [{key: 'name', value: null}],
        pagination: {
          offset: 0, limit: 8
        },
        loaded: true,
      }
    }),
    {
      onPageChange: state => (offset) => {
        return getPaginationObject(state, { offset }, false)
      },
      setPagination: state => ({ count }) => {
        return getPaginationObject(state, { count }, true)
      },
      setFilters: state => newFilters => ({
        ...state,
        filters: {
          ...state.filters,
          ...newFilters,
          loaded: false,
        }
      }),
    }
  ),
  withHandlers({
    onSearchChange: ({ setFilters }) => (value) => {
      setFilters({search: [{key: 'name', value}]})
    },
    onTableSortClick: ({ setFilters }) => (orderBy) => {
      setFilters({ orderBy: [orderBy] })
    },
    onTableSelectableClick: ({ 
      actions, organisation, group, filters, setPagination
    }) => (user) => {
      actions.deleteUserFromGroup(organisation, group, user, () => {
        actions.showToast(toastModule.SUCCESS_TOAST, `${user.name} has been removed from ${group.name}`)
        actions.getGroupPeople(organisation, group, filters, setPagination)
      })
    }
  }),
  lifecycle({
    componentDidMount() {
      const { 
        track, actions, organisation, group, filters, setPagination
      } = this.props

      track(SCREEN_VIEW_GROUP_VIEWERS)
      actions.getGroupPeople(organisation, group, filters, setPagination)
    },
    componentDidUpdate(prevProps) {
      const {
        actions, organisation, group, filters, setPagination
      } = this.props

      if (!isEqual(filters, prevProps.filters) && !filters.loaded) {
        actions.getGroupPeople(organisation, group, filters, setPagination)
      }
    }
  })
)



// WEBPACK FOOTER //
// ./src/containers/groups/ManageGroupViewers/ManageGroupViewers.enhancer.js